import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../../../app/js/utils/responsive_utilities';
import { styledFont } from '../../../../common/mixins/mixin';
import { deepCoveDark, indigo, Perano, white } from "../../../../../../app/js/components/loggedout/shared-styles/Colors";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${deepCoveDark};
  position: relative;
  ${styledFont("Graphie")}
  padding-top: 5.6rem;

`

export const HeadingText = styled(Heading1)`
  width: 90%;
  color: ${white};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 2.8, 3.2, 7)}

  @media ${device.Desktop}{
    ${styledFont("Graphie", 4, 4.8, 7)}
  }
`

export const SubHeadingText = styled(SubHeading)`
  width: 83%;
  color: ${white};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 1.6, 2, 6)}

  @media ${device.Tablet}{
    width: 65%;
  }
  
  @media ${device.Desktop}{
    ${styledFont("Graphie", 2, 2.4, 6)}
  }

`

export const ParentReviewSection = styled.div`
  display: flex;
  background: ${Perano};
  box-shadow: -0.2rem 0.4rem 4.5rem rgb(0 0 0 / 13%);
  border-radius: 0.8rem;
  width: 73%;
  margin: 3.2rem auto;
  padding: 1.2rem;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: relative;
  @media (min-width:${breakpoints.md}px){
    display: none;
  }
`

export const ImageWrapper = styled.div`
  padding-right: 1rem;
`

export const Review = styled.p`
  color: #0A0B4A;
  ${styledFont("Graphie",1.4, 1.7, 4)}

`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding-bottom: 7.2rem;

  > div{
    z-index: 2;
    width: 30rem;
  }
`

export const AnimationWrapper = styled.div`
  min-height: 20rem;
  margin: 3.8rem auto 3rem auto;
  position: relative;
  z-index: 2;
  @media (min-width:${breakpoints.md}px){
    min-height: 45rem;
    width: auto;
    margin: 4rem auto 3rem auto;
    padding-left: 7rem;
    box-sizing: border-box;
  }

  @media ${device.Desktop}{
    width: 99rem;
    margin: 3.5rem auto 3rem auto;
  }
`

export const BackgroundWrapper = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;

  >img{
    width: 100%;
    display: block;
  }
`
